<template lang="pug">
  section.center
    transition( name="description" )
      .container
        .display {{ getYear }}/{{ getMonth }}/{{ getDay }}
        .calender
          datepicker( 
            v-model="date",
            :inline="true",
            :disabledDates="disabledDates",
            @input="onUpdate"
          )
        .menu
          .btn( @click="onFix" ) 
            p CONFIRM
          .btn.no( @click="onBack" ) 
            p BACK
</template>

<script>
import Datepicker from "vuejs-datepicker";

export default {
  components: { Datepicker },

  data() {
    return {
      date: new Date(2019, 11, 31),
      disabledDates: {
        ranges: [
          { from: new Date(0, 0, 1), to: new Date() },
          { from: new Date(2020, 0, 0), to: new Date(9999, 11, 31) }
        ]
      }
    };
  },

  computed: {
    getYear() {
      return this.date.getFullYear();
    },

    getMonth() {
      return this.date.getMonth() + 1;
    },

    getDay() {
      return this.date.getDate();
    }
  },

  mounted() {
    let tomorrow = new Date();
    this.disabledDates.ranges[0].to = tomorrow;
  },

  methods: {
    onUpdate() {
      this.$emit("onUpdate", this.date);
    },

    onFix() {
      this.$emit("onFix", this.date);
    },

    onBack() {
      this.$emit("onBack");
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  padding-top: 0 !important;
}

.calender /deep/ {
  .vdp-datepicker__calendar {
    padding: 2rem;
  }

  .day__month_btn,
  .month__year_btn {
    font-family: "ELECNA", sans-serif;
    font-size: 2rem;
  }

  .cell {
    font-family: "ELECNA", sans-serif;

    &.day-header {
      font-size: 1.6rem;
    }

    &.month {
      font-size: 1.6rem;
    }

    &.day {
      font-size: 1.6rem;

      &.selected {
        color: #fff;
        background-color: #000;
      }
    }
  }
}

.display {
  font-family: "ELECNA", sans-serif;
  width: 100%;
  height: 60px;
  margin: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(255, 255, 255);
  font-size: 3rem;
}
</style>
